import { useState } from "react";
import { faqs } from "@/mocks/verify";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            FAQ
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[2rem]">
            关于求真与反转的常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            我们如何判断“实锤”与“反转”，澄清算不算数……这些疑问的答案都在下面。
          </p>
        </div>

        <div className="mt-9 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        isOpen ? "bg-primary-600 text-background-50" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-heading text-base font-bold text-foreground-950 md:text-[17px]">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-lg text-primary-600`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[3.25rem] md:px-6 md:pl-[3.75rem]">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}